import {
  FaFacebook,
  FaFacebookSquare,
  FaInstagram,
  FaInstagramSquare,
  FaPinterest,
  FaPinterestSquare,
  FaRegUser,
  FaTwitterSquare,
  FaYoutube,
  FaYoutubeSquare,
} from 'react-icons/fa';

import {
  MdAdd,
  MdArrowForward,
  MdCancel,
  MdChevronLeft,
  MdChevronRight,
  MdClose,
  MdContentCopy,
  MdDone,
  MdError,
  MdMenu,
  MdNewspaper,
  MdOutlineExpandLess,
  MdOutlineExpandMore,
  MdOutlineFileDownload,
  MdOutlineOpenInNew,
  MdPlayCircle,
  MdRemove,
  MdRssFeed,
  MdSearch,
  MdSearchOff,
} from 'react-icons/md';

import Bin from './svg/bin.svg';
import Cookie from './svg/cookie.svg';
import ElleAccordion from './svg/elle-accordion.svg';
import Facebook from './svg/facebook.svg';
import FilledArrow from './svg/filledArrow.svg';
import Pinterest from './svg/pinterest.svg';
import Sent from './svg/sent.svg';
import SliderArrow from './svg/sliderArrow.svg';
import TeaserArrow from './svg/teaser-arrow.svg';
import Tiktok from './svg/tiktok.svg';
import Twitter from './svg/twitter.svg';

export const iconsDictionary = {
  add: MdAdd,
  arrowForward: MdArrowForward,
  bin: Bin,
  cancel: MdCancel,
  chevronLeft: MdChevronLeft,
  chevronRight: MdChevronRight,
  close: MdClose,
  copy: MdContentCopy,
  done: MdDone,
  download: MdOutlineFileDownload,
  elleAccordion: ElleAccordion,
  error: MdError,
  externalLink: MdOutlineOpenInNew,
  facebook: Facebook,
  filledArrow: FilledArrow,
  facebookRound: FaFacebook,
  facebookSquare: FaFacebookSquare,
  instagram: FaInstagram,
  instagramSquare: FaInstagramSquare,
  menu: MdMenu,
  newspaper: MdNewspaper,
  pinterest: Pinterest,
  pinterestRound: FaPinterest,
  pinterestSquare: FaPinterestSquare,
  playCircle: MdPlayCircle,
  remove: MdRemove,
  rssFeed: MdRssFeed,
  search: MdSearch,
  searchOff: MdSearchOff,
  sent: Sent,
  showLess: MdOutlineExpandLess,
  showMore: MdOutlineExpandMore,
  sliderArrow: SliderArrow,
  tiktok: Tiktok,
  twitter: Twitter,
  twitterSquare: FaTwitterSquare,
  user: FaRegUser,
  youtube: FaYoutube,
  youtubeSquare: FaYoutubeSquare,
  teaserArrow: TeaserArrow,
  cookie: Cookie,
};
